<template>
  <div>
    <div v-for="(value, key) in orders['2020_6']">
      {{ key }}
      <span v-if="users && users[key]">{{ users[key].first_name }} {{ users[key].last_name }}</span>
    </div>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'labels',
        data(){
            return {
                pack: false,
                view: 'list',
                menu: false,
                toggle_exclusive: 0,
                selectedItem: 0,
                loading: false,
                search: '',
                dayIndex: 0,
                values: [],
                selected: [],
                headers: []
            }
        },
        computed: {
            ...mapGetters({
                'companies': 'getCompanies',
                'orders': 'getOrders',
                'users': 'getUsers',
                'substitutions': 'getSubstitutions',
                'plans': 'getPlans'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Labels.vue